export default {"src":"/_next/static/media/kotlin.02ff0930.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};